<template>
  <div style="background: linear-gradient(45deg, #28a745, #20c997); padding: 20px 0;">
    <layouts-header />
    <breadcrumb :title="title" :text="text" :text1="text1" />
  </div>
  <!-- About -->
  <aboutexperiences></aboutexperiences>
  <!-- /About -->

  <!-- services -->
  <!-- <service></service> -->
  <!-- /services -->

  <!-- Facts By The Numbers -->
  <!-- <factnumbers></factnumbers> -->
  <!-- /Facts By The Numbers -->

  <!-- Why Choose Us -->
  <!-- <choose-us></choose-us> -->
  <!-- /Why Choose Us -->

  <!-- About us Testimonials -->
  <!-- <testimonial></testimonial> -->
  <!-- About us Testimonials -->

  <!-- FAQ  -->
  <!-- <faq></faq> -->
  <!-- /FAQ -->
  <layout-footer></layout-footer>
</template>

<script>
export default {
  data() {
    return {
      title: "من نحن",
      text: "الصفحات",
      text1: "من نحن",
    };
  },
};
</script>
<style scoped>

</style>
